export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/contactIconGreen.ea9cc79e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};